import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScrollToTop";

import useVisitsManager from "./hooks/useVisitsManager";

import VisitsHeader from "./components/VisitsHeader";
import VisitsStats from "./components/VisitsStats";
import VisitsChartCard from "./components/VisitsChartCard";
import VisitsDeletePanel from "./components/VisitsDeletePanel";
import VisitsTable from "./components/VisitsTable";

export default function Visites() {
  useScrollToTop();

  const {
    rows,
    stats,
    loading,
    deleting,
    demoMode,
    dateDebut,
    dateFin,

    setDateDebut,
    setDateFin,
    refreshData,
    handleDeleteVisits,
  } = useVisitsManager();

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5">
        <VisitsHeader
          loading={loading}
          demoMode={demoMode}
          onRefresh={refreshData}
        />

        <VisitsStats stats={stats} />

        <div className="grid gap-5 xl:grid-cols-[minmax(0,1fr)_420px]">
          <VisitsChartCard rows={rows} loading={loading} />

          <div className="space-y-5">
            <VisitsDeletePanel
              dateDebut={dateDebut}
              dateFin={dateFin}
              deleting={deleting}
              demoMode={demoMode}
              onDateDebutChange={setDateDebut}
              onDateFinChange={setDateFin}
              onDelete={handleDeleteVisits}
            />

            {/* <VisitsTable rows={rows} loading={loading} /> */}
          </div>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
}